import { create } from 'zustand'

interface User {
  id: number
  username: string
  email: string
  level: number
  exp: number
  coins: number
  energy: number
  max_energy: number
}

interface Card {
  id: number
  name: string
  attribute: string
  rarity: string
  base_damage: number
  base_hp: number
  skill_type: string
  skill_triggers: any
  description: string
  image_url: string
  count?: number
  level?: number
}

interface Team {
  id: number
  name: string
  card_slots: number[]
  is_active: boolean
}

interface GameState {
  // Auth
  token: string | null
  user: User | null
  isLoggedIn: boolean

  // Game Data
  cards: Card[]
  userCards: Card[]
  teams: Team[]
  currentTeam: Team | null
  announcements: any[]

  // Actions
  setToken: (token: string) => void
  setUser: (user: User) => void
  logout: () => void
  setCards: (cards: Card[]) => void
  setUserCards: (cards: Card[]) => void
  setTeams: (teams: Team[]) => void
  setCurrentTeam: (team: Team) => void
  setAnnouncements: (announcements: any[]) => void

  // Battle State
  inBattle: boolean
  battleState: any | null
  startBattle: () => void
  endBattle: () => void
  setBattleState: (state: any) => void

  // UI State
  currentPage: string
  setCurrentPage: (page: string) => void
}

export const useGameStore = create<GameState>((set) => ({
  // Auth
  token: localStorage.getItem('token'),
  user: null,
  isLoggedIn: !!localStorage.getItem('token'),

  // Game Data
  cards: [],
  userCards: [],
  teams: [],
  currentTeam: null,
  announcements: [],

  // Actions
  setToken: (token: string) => {
    localStorage.setItem('token', token)
    set({ token, isLoggedIn: true })
  },

  setUser: (user: User) => set({ user }),

  logout: () => {
    localStorage.removeItem('token')
    set({ token: null, user: null, isLoggedIn: false })
  },

  setCards: (cards: Card[]) => set({ cards }),
  setUserCards: (cards: Card[]) => set({ userCards: cards }),
  setTeams: (teams: Team[]) => set({ teams }),
  setCurrentTeam: (team: Team) => set({ currentTeam: team }),
  setAnnouncements: (announcements: any[]) => set({ announcements }),

  // Battle State
  inBattle: false,
  battleState: null,

  startBattle: () => set({ inBattle: true }),
  endBattle: () => set({ inBattle: false, battleState: null }),
  setBattleState: (state: any) => set({ battleState: state }),

  // UI State
  currentPage: 'home',
  setCurrentPage: (page: string) => set({ currentPage: page }),
}))
